"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CheckboxSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M25,17v8H7V7H17V5H7A2,2,0,0,0,5,7V25a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V17Z"/><path d="M16,21a1.009,1.009,0,0,1-.641-.231l-6-5a1,1,0,1,1,1.282-1.536l5.171,4.31L25.187,5.419a1,1,0,1,1,1.626,1.162l-10,14a1,1,0,0,1-.685.411A1.113,1.113,0,0,1,16,21Z"/>';
var CheckboxSVG = function CheckboxSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.CheckboxSVG = CheckboxSVG;
CheckboxSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CheckboxSVG);
exports.default = _default;